<template>
    <div>
        <!-- Desktop -->
        <v-container v-if="!$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly"
                     fluid pl-4 pr-1 class="dettagli-wrapper">
            <v-row>
                <v-col cols="6" class="dettagli-row">
                    <List />
                </v-col>
                <v-col cols="6" class="dettagli_utente dettagli-row">
                    <div class="text-right close" @click="goRouterBack">
                        <i class="mdi mdi-close-circle-outline"/>
                    </div>
                    <Associati :action="'associa'" :days="7"/>
                </v-col>
            </v-row>
        </v-container>

        <!-- Mobile / tablet: tab -->
        <div v-else>
            <div class="text-right close mt-2 mr-2" @click="goRouterBack">
                <i class="mdi mdi-close-circle-outline" style="font-size: 32px"/>
            </div>
            <v-tabs v-model="tab"
                    background-color="transparent"
                    color="primary"
                    grow>
                <v-tab href="#tab-info">
                    <v-icon left>mdi-information-outline</v-icon>
                    Info
                </v-tab>
                <v-tab href="#tab-assegna">
                    <v-icon left>mdi-account-plus</v-icon>
                    Assegna
                </v-tab>
            </v-tabs>
            <hr>
            <v-tabs-items v-model="tab">
                <v-tab-item value="tab-info">
                    <List />
                </v-tab-item>
                <v-tab-item value="tab-assegna">
                    <Associati :action="'associa'" :days="7"/>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>
<script>
import Associati from '@/components/gestione/associati/Associati';
import List from '@/components/utenti/Lista';

export default {
    name: 'DettagliGestione',
    components: { Associati, List },
    data() {
        return {
            tab: 'tab-info'
        }
    },
    methods: {
        goRouterBack() {
            this.$router.back();
        },
    }
}
</script>